import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login';

import { OopsComponent } from './oops';

import {
  DashboardComponent,
  EquipmentsComponent,
  InvoiceComponent,
  ReportsComponent,
  ServiceOrderComponent,
  ServiceOrderManagementComponent,
  ServiceProvidersComponent,
  ServicesComponent,
  PanelComponent,
  EquipmentsListComponent,
  ServicesListComponent,
  ServiceProvidersListComponent,
  EquipmentsNewComponent,
  ServiceProvidersNewComponent,
  ServicesNewComponent,
  EquipmentsEditComponent,
  ServiceProvidersEditComponent,
  ServicesEditComponent,
  ServiceOrderListComponent,
  ServiceOrderNewComponent,
  ServiceOrderReturnComponent,
  ServiceOrderViewComponent,
  ServiceOrderManagementListComponent,
  ServiceOrderManagementViewComponent,
  InvoiceListComponent,
  ReportsListComponent,
  InvoiceViewComponent,
  SupervisorComponent,
  SupervisorEditComponent,
  SupervisorListComponent,
  SupervisorNewComponent,
  ServiceOrderEditComponent
} from './panel';

import { AuthGuard } from './shared';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'panel',
    component: PanelComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/panel/dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'equipments',
        component: EquipmentsComponent,
        children: [
          {
            path: '',
            redirectTo: '/panel/equipments/list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            component: EquipmentsListComponent
          },
          {
            path: 'list/:pag',
            component: EquipmentsListComponent
          },
          {
            path: 'new',
            component: EquipmentsNewComponent
          },
          {
            path: 'edit/:id',
            component: EquipmentsEditComponent
          }
        ]
      },
      {
        path: 'invoice',
        component: InvoiceComponent,
        children: [
          {
            path: '',
            redirectTo: '/panel/invoice/list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            component: InvoiceListComponent
          },
          {
            path: 'list/:pag',
            component: InvoiceListComponent
          },
          {
            path: 'view/:id',
            component: InvoiceViewComponent
          }
        ]
      },
      {
        path: 'reports',
        component: ReportsComponent,
        children: [
          {
            path: '',
            redirectTo: '/panel/reports/list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            component: ReportsListComponent
          }
        ]
      },
      {
        path: 'service-order',
        component: ServiceOrderComponent,
        children: [
          {
            path: '',
            redirectTo: '/panel/service-order/list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            component: ServiceOrderListComponent
          },
          {
            path: 'list/:pag',
            component: ServiceOrderListComponent
          },
          {
            path: 'new',
            component: ServiceOrderNewComponent
          },
          {
            path: 'view/:id',
            component: ServiceOrderViewComponent
          },
          {
            path: 'edit/:id',
            component: ServiceOrderEditComponent
          },
          {
            path: 'return/:id',
            component: ServiceOrderReturnComponent
          }
        ]
      },
      {
        path: 'service-order-management',
        component: ServiceOrderManagementComponent,
        children: [
          {
            path: '',
            redirectTo: '/panel/service-order-management/list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            component: ServiceOrderManagementListComponent
          },
          {
            path: 'view/:id',
            component: ServiceOrderManagementViewComponent
          },
        ]
      },
      {
        path: 'service-providers',
        component: ServiceProvidersComponent,
        children: [
          {
            path: '',
            redirectTo: '/panel/service-providers/list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            component: ServiceProvidersListComponent
          },
          {
            path: 'list/:pag',
            component: ServiceProvidersListComponent
          },
          {
            path: 'new',
            component: ServiceProvidersNewComponent
          },
          {
            path: 'edit/:id',
            component: ServiceProvidersEditComponent
          }
        ]
      },
      {
        path: 'services',
        component: ServicesComponent,
        children: [
          {
            path: '',
            redirectTo: '/panel/services/list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            component: ServicesListComponent
          },
          {
            path: 'list/:id',
            component: ServicesListComponent
          },
          {
            path: 'new',
            component: ServicesNewComponent
          },
          {
            path: 'edit/:id',
            component: ServicesEditComponent
          }
        ]
      },
      {
        path: 'supervisor',
        component: SupervisorComponent,
        children: [
          {
            path: '',
            redirectTo: '/panel/supervisor/list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            component: SupervisorListComponent
          },
          {
            path: 'list/:pag',
            component: SupervisorListComponent
          },
          {
            path: 'new',
            component: SupervisorNewComponent
          },
          {
            path: 'edit/:id',
            component: SupervisorEditComponent
          }
        ]
      }
    ]
  },
  {
    path: '**',
    component: OopsComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
